module.exports = __webpack_public_path__ + "static/media/thoughts3.91179f3c.jpg";